import React from 'react';
import { Link } from 'gatsby';

import Logo from './icons/logo.svg';
import LogoUz from './icons/logo-uz.svg';
import { useTheme } from '../../contexts/Theme.context';
import { ThemeType } from '../../contexts/Theme.model';

interface Props {
  linkClass?: string;
}

const LinkLogo = ({ linkClass }: Props) => {
  const { themeType } = useTheme();
  const logoSRC = themeType === ThemeType.enTheme ? <Logo /> : <LogoUz />;

  return (
    <Link to="/" className={`header-logo-link ${linkClass}`}>
      {logoSRC}
    </Link>
  );
};

export default LinkLogo;
